// Module
var code = `<button class="btn clear" type="button" ng-click="exportButtonController.export()" ng-disabled="exportButtonController.isDisabled" ng-class="exportButtonController.buttonTypeClass"> <i class="fa fa-download" aria-hidden="true"></i> <span translate>Generic.Export</span> </button> `;
// Exports
module.exports = code;